import injector from 'vue-inject'
import * as types from './mutation-types'
import * as itemTypes from './itemModule/mutation-types'
import { storeClient } from '@/service/apiClients'
import moment from 'moment'

export default {
  async setStore ({ getters, commit }, storeId) {
    if (getters.storeId !== storeId) {
      try {
        const { data: store } = await storeClient.get(`/stores/${storeId}/publicInfo`)

        commit(types.SET_STORE, store)
      } catch (e) {
        console.error('setStore connection error' + e)
      }
    }
  },
  setMenuUrl ({ commit }, url) {
    commit(types.SET_MENU_URL, url)
  },
  setMenuVariation ({ state, commit }, variation) {
    if (state.menuVariation !== variation) {
      commit(types.SET_MENU_VARIATION, variation)
    }
  },
  setDiningPreference ({ dispatch, commit }, diningPreference) {
    if (diningPreference) {
      switch (diningPreference) {
        case injector.get('diningPreferenceType').forHere:
        case injector.get('diningPreferenceType').takeAway:
        case injector.get('diningPreferenceType').preOrder:
          commit(types.SET_DINING_PREFERENCE, diningPreference)
      }
    }
  },
  async getTableNumbers ({ rootState, commit, rootGetters }) {
    const { data: tableNumbers } = await storeClient.get(`stores/${rootGetters.storeId}/tableNumbers`)
    commit(types.SET_TABLE_NUMBERS, tableNumbers)
  },
  setNickname ({ commit }, nickname) {
    commit(types.SET_NICKNAME, nickname)
  },
  setOrderPublicId ({ commit }, publicId) {
    commit(types.SET_QR_CODE, publicId)
  },
  setAgentId ({ commit }, agentId) {
    commit(types.SET_AGENT_ID, agentId)
  },
  setTableNumber ({ commit }, tableNumber) {
    if (tableNumber) {
      commit(types.SET_TABLE_NUMBER, tableNumber.toUpperCase())
    }
  },
  setPhoneNumber ({ commit }, phoneNumber) {
    if (phoneNumber) {
      commit(types.SET_PHONE_NUMBER, phoneNumber)
    }
  },
  setPickupTime ({ commit }, pickupTime) {
    commit(types.SET_PICKUP_TIME, pickupTime)
  },
  setTaxId ({ commit }, taxId) {
    commit(types.SET_TAX_ID, taxId)
  },
  setInvoiceTitle ({ commit }, invoiceTitle) {
    commit(types.SET_INVOICE_TITLE, invoiceTitle)
  },
  setReceiptCarrier ({ commit }, receiptCarrier) {
    commit(types.SET_RECEIPT_CARRIER, receiptCarrier)
  },
  setReceiptCarrierId ({ commit }, id) {
    commit(types.SET_RECEIPT_CARRIER_ID, id)
  },
  setPaymentMethod ({ commit }, paymentMethod) {
    commit(types.SET_PAYMENT_METHOD, paymentMethod)
  },
  setPaymentMethodDiscount ({ commit }, paymentMethodDiscount) {
    commit(types.SET_PAYMENT_METHOD_DISCOUNT, paymentMethodDiscount)
  },
  setOrderParams ({ commit }, params) {
    commit(types.SET_ORDER_PARAMS, params)
  },
  resetOrderParams ({ commit }) {
    commit(types.RESET_ORDER_PARAMS)
  },
  async deleteOrder ({ state, getters, commit }, publicId) {
    try {
      await storeClient.delete(`/stores/${getters.storeId}/orders/${publicId}`)
      commit('itemModule/' + itemTypes.RESET_BUCKET, { itemBucket: 'cart' })
      commit(types.RESET_ORDER_PARAMS)
    } catch (e) {
      throw e
    }
  },
  async downloadBusinessHours ({ rootGetters, commit }, menuVariation) {
    const { data: businessHoursTable } = await storeClient.get(`/stores/${rootGetters.storeId}/businessHours?v=${menuVariation.menuVariation}&s=${moment().format('YYYY-MM-DD')}&e=${moment().add(this.acceptDaysAmount - 1, 'd').format('YYYY-MM-DD')}`)
    commit(types.SET_BUSINESS_HOURS, businessHoursTable)
  }
}
